module.exports = __webpack_public_path__ + "static/media/header_a_mobile_1020.b2af2662.png";